import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=e9a8d18a&scoped=true&"
import script from "./Whiteboard.vue?vue&type=script&lang=js&"
export * from "./Whiteboard.vue?vue&type=script&lang=js&"
import style0 from "./Whiteboard.vue?vue&type=style&index=0&id=e9a8d18a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a8d18a",
  null
  
)

export default component.exports